import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Popup} from 'react-leaflet';
import {Icon} from 'react-fa';

import moment from 'moment';
import momentDF from 'moment-duration-format';

import api from "utils/api";
import RouterForwarder from 'utils/RouterForwarder';

import RealTime from "./RealTime";
import DepartureList from "./DepartureList";


class StopPopup extends Component {
    static contextTypes = {
        router: PropTypes.object.isRequired
    };

    state = {
        loading: false,
        routes: {},
        departures: {},
    };

    fetchLiveTimes = () => {
        api.live.fetch(null, {stop_id: this.props.stop.stop_id}).then(liveDepartures => {
            const departures = {};
            liveDepartures.map(dep => {
                const departure = this.state.departures[dep.stoptime_id];
                if (departure) {
                    departures[departure.id] = {
                        ...departure,
                        live: true,
                        departure: moment(dep.estimated, 'HH:mm:ss'),
                        liveScheduled: moment(dep.scheduled, 'HH:mm:ss'),
                    };
                }
            });

            this.setState({
                departures: {
                    ...this.state.departures,
                    ...departures,
                }
            })
        });
    };

    loadDepartures = () => (
        api.quickDeps.fetch(null, {stop_id: this.props.stop.stop_id}).then(routes => {
            const newRoutes = {};
            const newDepartures = {};
            routes.map(route => {
                const {upcoming_departures, ...rest} = route;
                newRoutes[route.route_id] = {...rest};
                upcoming_departures.forEach(dep => {
                    const depMoment = moment(`${dep.date} ${dep.departure_time}`);
                    newDepartures[dep.id] = {
                        ...dep,
                        live: false,
                        departure_time: depMoment,
                        departure: depMoment,
                        route: route.route_id,
                    };
                });
            });

            this.setState({
                routes: {
                    ...this.state.routes,
                    ...newRoutes,
                },
                departures: {
                    ...this.state.departures,
                    ...newDepartures,
                }
            })
        })
    );

    onOpenPopup = () => {
        this.setState({loading: true});
        this.loadDepartures().then(() => {
            this.setState({loading: false});
            this.fetchLiveTimes();
            this.timer = setInterval(() => {
                this.fetchLiveTimes();
            }, 5000);
        });
    };

    onClosePopup = () => {
        clearInterval(this.timer);
    };

    sortedDepartures = () => {
        return Object.values(this.state.departures).sort((a, b) => a.departure - b.departure);
    };

    render() {
        const {stop} = this.props;
        const {loading, routes} = this.state;

        const departures = this.sortedDepartures();

        // if (departures.length) {
        //     console.log(departures);
        // }

        return (
            <Popup onOpen={this.onOpenPopup} onClose={this.onClosePopup}>
                <RouterForwarder context={this.context}>
                    <div className="stop">
                        <h4>
                            <span>{stop.stop_name}</span>
                            {loading ? (<Icon name="circle-o-notch" spin />) : null}
                            <span className="small" style={{marginLeft: 8}}>{stop.stop_id}</span>
                        </h4>
                        <div className="stop__schedules">
                            <RealTime>
                                <DepartureList stop={stop} routes={routes} departures={departures} />
                            </RealTime>
                        </div>
                    </div>
                </RouterForwarder>
            </Popup>
        );
    }
}

export default StopPopup;



// WEBPACK FOOTER //
// ./src/components/StopPopup.js